import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ResponsePerformersType } from './type';

const getToken = () => localStorage.getItem('token');

const getAuthorizationHeader = () => {
  const token = getToken();
  return token ? `Bearer ${token}` : '';
};

export const performersWorkSupport = createApi({
  reducerPath: 'performersWorkSupport',
  tagTypes: ['Employeds', 'Employed', 'Tags', 'EmployedsTabs'],
  refetchOnReconnect: true,
  keepUnusedDataFor: 15,
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/api/worksupport`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: getAuthorizationHeader(),
    },
  }),
  endpoints: (build) => ({
    getPerformersWorkSupport: build.query<ResponsePerformersType, void>({
      query: () => ({
        url: `workers-app/moderation-list`,
        method: 'GET',
      }),
      providesTags: () => ['Employeds'],
    }),
  }),
});

export const { useGetPerformersWorkSupportQuery } = performersWorkSupport;
